import React, { useState, useEffect } from 'react';
import { useLocation } from "react-router-dom";
import '../App.css';
import { useNavigate } from 'react-router-dom';
import event_card_img from '../img/events/event-view.jpg';
import BasicInformation from "../Create_event_details/BasicInformation";
import EventDuration from "../Create_event_details/EventDuration";
import EventDescription from "../Create_event_details/EventDescription";
import Tickets from "../Create_event_details/Tickets";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from '../axios';
import Loader from '../Loader';
import BreadcrumbBg from '../img/banner/breadcrumb-bg.jpg'
import HeaderSecond from '../HeaderSecond';
import FormQuestions from './FormQuestions';
import Integration from './Integration';
import Settings from './Settings';
import Communication from "../Create_event_details/Communication";
import EventFAQ from "../Create_event_details/EventFAQ";
import Coupons from "../Create_event_details/Coupons";
import AgeCriteria from "../Create_event_details/AgeCriteria";
import { UserAccessRights } from '../Custom';
import LoaderImg from '../img/logo/running.gif';

const CreateEvent = () => {
  // console.log("Create Event page");
  const navigate = useNavigate();
  const { state } = useLocation();

  const [EventTabs, setEventTabs] = useState(1);
  const [EventTabsClass1, setEventTabsClass1] = useState('');
  const [EventTabsClass2, setEventTabsClass2] = useState('');
  const [EventTabsClass3, setEventTabsClass3] = useState('');
  const [EventTabsClass4, setEventTabsClass4] = useState('');
  const [EventTabsClass5, setEventTabsClass5] = useState('');
  const [EventTabsClass6, setEventTabsClass6] = useState('');
  const [EventTabsClass7, setEventTabsClass7] = useState('');
  const [EventTabsClass8, setEventTabsClass8] = useState('');
  const [EventTabsClass9, setEventTabsClass9] = useState('');
  const [EventTabsClass10, setEventTabsClass10] = useState('');
  const [EventTabsClass11, setEventTabsClass11] = useState('');

  //console.log(BasicInfoFlag);
  const [EventResponceTabs, setEventResponceTabs] = useState(0);
  const [EventBasicInfoMsg, setEventBasicInfoMsg] = useState('');
  const [EventDurationMsg, setEventDurationMsg] = useState('');
  const [EventDescriptionMsg, setEventDescriptionMsg] = useState('');
  const [EventDetailsAll, setEventDetailsAll] = useState([]);
  const [EventTicketsAll, setEventTicketsAll] = useState([]);
  const [EventImagesAll, setEventImagesAll] = useState([]);
  const [EventCategoryAll, setEventCategoryAll] = useState([]);
  const [EventTypeAll, setEventTypeAll] = useState([]);
  const [EventCardPreview, setEventCardPreview] = useState([]);
  const [EventApiCall, setEventApiCall] = useState(true);
  const [DivClass, setDivClass] = useState('col-lg-8 col-md-6');
  const [TicketDivShowFlag, setTicketDivShowFlag] = useState(false);
  const [EventSettingDetails, setEventSettingDetails] = useState([]);
  const [FieldMappingDetails, setFieldMappingDetails] = useState([]);
  const [CommunicationDetails, setCommunicationDetails] = useState([]);
  const [FAQDetails, setFAQDetails] = useState([]);
  const [TicketsDetails, setTicketsDetails] = useState([]);
  const [CouponsDetails, setCouponsDetails] = useState([]);
  const [AgeCriteriaDetails, setAgeCriteriaDetails] = useState([]);
  const [AgeDetails, setAgeDetails] = useState([]);
  const [TermConditionsDetails, setTermConditionsDetails] = useState([]);
  const [EventName, setEventName] = useState('');
  const [FormTicketsDetails, setFormTicketsDetails] = useState([]);
  const [CouponTicketsDetails, setCouponTicketsDetails] = useState([]);
  const [RaceCategoryChargesDetails, setRaceCategoryChargesDetails] = useState([]);
  const [CategoriesAll, setCategoriesAll] = useState([]);

  const [YtcrFeePercent, setYtcrFeePercent] = useState('');
  const [PlatformFeePercent, setPlatformFeePercent] = useState('');
  const [PaymentGatewayFeePercent, setPaymentGatewayFeePercent] = useState('');
  const [PaymentGatewayGstPercent, setPaymentGatewayGstPercent] = useState('');
  const [loader, setLoader] = useState(false);
  const [oneTimeLoader, setOneTimeLoader] = useState(true);
  const [NewFlag, setNewFlag] = useState(0);
  const [TabClickFlag, setTabClickFlag] = useState(true);
  const [EventTcsPopupFlag, setEventTcsPopupFlag] = useState(0);
  const [EventDispName, setEventDispName] = useState('');
  const [OtherPlatformEvent, setOtherPlatformEvent] = useState(0);
  const [EditFlag, setEditFlag] = useState(0);
  const [EventSettingCategoryFlag, setEventSettingCategoryFlag] = useState(false);
  // console.log(EventDispName);
  //console.log(YtcrFeePercent);

  //---------------- New added
  const [EditEventId, setEditEventId] = useState(0);
  useEffect(() => {
    if (state) {
      setEditEventId(state.eventId);
      // setEventType(state.eventType);
      // console.log(state);
    }
  }, [state]);
  // console.log(EditEventId);

  const handleBackToHome = () => {
    localStorage.removeItem('EventViewFlag');
    localStorage.removeItem('EventDetailsId');

    const CountryCode = localStorage.getItem('CountryCode');
    const CountryName = localStorage.getItem('Country');
    navigate('/' + CountryCode + '/' + CountryName);
  }

  //console.log(EventCardPreview);
  const common_svg = "M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z";

  const [EventSvg1, setEventSvg1] = useState("m422-296 282-282-56-56-226 226-114-114-56 56 170 170Zm56 216q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Z");

  const green_tick_svg = "m422-296 282-282-56-56-226 226-114-114-56 56 170 170Zm56 216q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Z";

  const [EventSvg2, setEventSvg2] = useState(common_svg);
  const [EventSvg3, setEventSvg3] = useState(common_svg);
  const [EventSvg4, setEventSvg4] = useState(common_svg);
  const [EventSvg5, setEventSvg5] = useState(common_svg);
  const [EventSvg6, setEventSvg6] = useState(common_svg);
  const [EventSvg7, setEventSvg7] = useState(common_svg);
  const [EventSvg8, setEventSvg8] = useState(common_svg);
  const [EventSvg9, setEventSvg9] = useState(common_svg);
  const [EventSvg10, setEventSvg10] = useState(common_svg);
  const [EventSvg11, setEventSvg11] = useState(common_svg);

  useEffect(() => {

    if (EventResponceTabs === 0) {      // Event Essentials
      setEventTabs(1);
    } else if (EventResponceTabs === 1) { // Event Scheduling
      setEventTabs(2);
    } else if (EventResponceTabs === 2) { // Event Description
      setEventTabs(3);
    } else if (EventResponceTabs === 3) {  // Event Settings
      setEventTabs(4);
    } else if (EventResponceTabs === 4) {  // Tickets 
      setEventTabs(5);
    } else if (EventResponceTabs === 5) { // Form Questions
      setEventTabs(6);
    } else if (EventResponceTabs === 6) { // Age Category
      setEventTabs(7);
    } else if (EventResponceTabs === 7) { // Discount Coupons
      setEventTabs(8);
    } else if (EventResponceTabs === 8) { // Communications
      setEventTabs(9);
    } else if (EventResponceTabs === 9) { // FAQ's 
      setEventTabs(10);
    }  else if (EventResponceTabs === 10) { // Support
      setEventTabs(11);
    }
    setEventApiCall(true)

  }, [EventBasicInfoMsg, EventDescriptionMsg, EventDurationMsg, EventResponceTabs])

  const mainUrlLink = window.location.origin;
  //------------- get event details ----------------
  useEffect(() => {
    if ((EventApiCall && !isNaN(EditEventId)) || EventSettingCategoryFlag) {
      //  console.log(EventResponceTabs,EventTabs);
      if (EventTabs === 1) {    // --------- Event Essentials

        setEventTabsClass1('active'); setEventTabsClass2(''); setEventTabsClass3(''); setEventTabsClass4(''); setEventTabsClass5(''); setEventTabsClass6(''); setEventTabsClass7(''); setEventTabsClass8(''); setEventTabsClass9(''); setEventTabsClass10(''); setEventTabsClass11('');
        setEventSvg1(green_tick_svg); setEventSvg2(common_svg); setEventSvg3(common_svg); setEventSvg4(common_svg); setEventSvg5(common_svg); setEventSvg6(common_svg); setEventSvg7(common_svg); setEventSvg8(common_svg); setEventSvg9(common_svg); setEventSvg10(common_svg); setEventSvg11(common_svg); 

      } else if (EventTabs === 2) {    // --------- Event Scheduling

        setEventTabsClass1(''); setEventTabsClass2('active'); setEventTabsClass3(''); setEventTabsClass4(''); setEventTabsClass5(''); setEventTabsClass6(''); setEventTabsClass7(''); setEventTabsClass8(''); setEventTabsClass9(''); setEventTabsClass10(''); setEventTabsClass11('');
        setEventSvg1(common_svg); setEventSvg2(green_tick_svg); setEventSvg3(common_svg); setEventSvg4(common_svg); setEventSvg5(common_svg); setEventSvg6(common_svg); setEventSvg7(common_svg); setEventSvg8(common_svg); setEventSvg9(common_svg);
        setEventSvg10(common_svg); setEventSvg11(common_svg); 

      } else if (EventTabs === 3) {    // --------- Event Description

        setEventTabsClass1(''); setEventTabsClass2(''); setEventTabsClass3('active'); setEventTabsClass4(''); setEventTabsClass5(''); setEventTabsClass6(''); setEventTabsClass7(''); setEventTabsClass8(''); setEventTabsClass9(''); setEventTabsClass10(''); setEventTabsClass11('');
        setEventSvg1(common_svg); setEventSvg2(common_svg); setEventSvg3(green_tick_svg); setEventSvg4(common_svg); setEventSvg5(common_svg); setEventSvg6(common_svg); setEventSvg7(common_svg); setEventSvg8(common_svg); setEventSvg9(common_svg);
        setEventSvg10(common_svg); setEventSvg11(common_svg); 

      } else if (EventTabs === 4) {   // --------- Event Settings

        setEventTabsClass1(''); setEventTabsClass2(''); setEventTabsClass3(''); setEventTabsClass4('active'); setEventTabsClass5(''); setEventTabsClass6(''); setEventTabsClass7(''); setEventTabsClass8(''); setEventTabsClass9(''); setEventTabsClass10(''); setEventTabsClass11('');
        setEventSvg1(common_svg); setEventSvg2(common_svg); setEventSvg3(common_svg);  setEventSvg4(green_tick_svg); setEventSvg5(common_svg); setEventSvg6(common_svg); setEventSvg7(common_svg); setEventSvg8(common_svg); setEventSvg9(common_svg); setEventSvg10(common_svg); setEventSvg11(common_svg);

      } else if (EventTabs === 5) {    // --------- Tickets

        setEventTabsClass1(''); setEventTabsClass2(''); setEventTabsClass3(''); setEventTabsClass4(''); setEventTabsClass5('active'); setEventTabsClass6(''); setEventTabsClass7(''); setEventTabsClass8(''); setEventTabsClass9(''); setEventTabsClass10(''); setEventTabsClass11('');
        setEventSvg1(common_svg); setEventSvg2(common_svg); setEventSvg3(common_svg); setEventSvg4(common_svg); setEventSvg5(green_tick_svg); setEventSvg6(common_svg); setEventSvg7(common_svg); setEventSvg8(common_svg); setEventSvg9(common_svg);
        setEventSvg10(common_svg); setEventSvg11(common_svg); 

      } else if (EventTabs === 6) {    // --------- Form Questions

        setEventTabsClass1(''); setEventTabsClass2(''); setEventTabsClass3(''); setEventTabsClass4(''); setEventTabsClass5(''); setEventTabsClass6('active'); setEventTabsClass7(''); setEventTabsClass8(''); setEventTabsClass9(''); setEventTabsClass10(''); setEventTabsClass11('');
        setEventSvg1(common_svg); setEventSvg2(common_svg); setEventSvg3(common_svg); setEventSvg4(common_svg); setEventSvg5(common_svg); setEventSvg6(green_tick_svg);
        setEventSvg7(common_svg); setEventSvg8(common_svg); setEventSvg9(common_svg);
        setEventSvg10(common_svg); setEventSvg11(common_svg); 

      } else if (EventTabs === 7) {    // --------- Age Category

        setEventTabsClass1(''); setEventTabsClass2(''); setEventTabsClass3(''); setEventTabsClass4(''); setEventTabsClass5(''); setEventTabsClass6(''); setEventTabsClass7('active'); setEventTabsClass8(''); setEventTabsClass9(''); setEventTabsClass10(''); setEventTabsClass11('');
        setEventSvg1(common_svg); setEventSvg2(common_svg); setEventSvg3(common_svg); setEventSvg4(common_svg); setEventSvg5(common_svg); setEventSvg6(common_svg); setEventSvg7(green_tick_svg); setEventSvg8(common_svg); setEventSvg9(common_svg);
        setEventSvg10(common_svg); setEventSvg11(common_svg); 

      } else if (EventTabs === 8) {  // --------- Discount Coupons

        setEventTabsClass1(''); setEventTabsClass2(''); setEventTabsClass3(''); setEventTabsClass4(''); setEventTabsClass5(''); setEventTabsClass6(''); setEventTabsClass7(''); setEventTabsClass8('active'); setEventTabsClass9(''); setEventTabsClass10(''); setEventTabsClass11('');
        setEventSvg1(common_svg); setEventSvg2(common_svg); setEventSvg3(common_svg); setEventSvg4(common_svg); setEventSvg5(common_svg); setEventSvg6(common_svg); setEventSvg7(common_svg); setEventSvg8(green_tick_svg); setEventSvg9(common_svg);
        setEventSvg10(common_svg); setEventSvg11(common_svg); 

      } else if (EventTabs === 9) {    // --------- Communications

        setEventTabsClass1(''); setEventTabsClass2(''); setEventTabsClass3(''); setEventTabsClass4(''); setEventTabsClass5(''); setEventTabsClass6(''); setEventTabsClass7(''); setEventTabsClass8(''); setEventTabsClass9('active'); setEventTabsClass10(''); setEventTabsClass11('');
        setEventSvg1(common_svg); setEventSvg2(common_svg); setEventSvg3(common_svg); setEventSvg4(common_svg); setEventSvg5(common_svg); setEventSvg6(common_svg); setEventSvg7(common_svg); setEventSvg8(common_svg); setEventSvg9(green_tick_svg); setEventSvg10(common_svg); setEventSvg11(common_svg); 

      } else if (EventTabs === 10) {    // --------- FAQ's

        setEventTabsClass1(''); setEventTabsClass2(''); setEventTabsClass3(''); setEventTabsClass4(''); setEventTabsClass5(''); setEventTabsClass6(''); setEventTabsClass7(''); setEventTabsClass8(''); setEventTabsClass9(''); setEventTabsClass10('active'); setEventTabsClass11('');
        setEventSvg1(common_svg); setEventSvg2(common_svg); setEventSvg3(common_svg); setEventSvg4(common_svg); setEventSvg5(common_svg); setEventSvg6(common_svg); setEventSvg7(common_svg); setEventSvg8(common_svg); setEventSvg9(common_svg);  setEventSvg10(green_tick_svg); setEventSvg11(common_svg);

      } else if (EventTabs === 11) {   // --------- Support

        setEventTabsClass1(''); setEventTabsClass2(''); setEventTabsClass3(''); setEventTabsClass4(''); setEventTabsClass5(''); setEventTabsClass6(''); setEventTabsClass7(''); setEventTabsClass8(''); setEventTabsClass9(''); setEventTabsClass10(''); setEventTabsClass11('active');
        setEventSvg1(common_svg); setEventSvg2(common_svg); setEventSvg3(common_svg); setEventSvg4(common_svg); setEventSvg5(common_svg); setEventSvg6(common_svg); setEventSvg7(common_svg); setEventSvg8(common_svg); setEventSvg9(common_svg); setEventSvg10(common_svg); setEventSvg11(green_tick_svg);

      } else {
        setEventTabsClass1('');
      }
      //console.log(EventTabs);
      //-------------------------
      setLoader(true);

      const payload = {
        event_id: EditEventId !== 0 ? EditEventId : 0,
        url_link: mainUrlLink
      };
      // console.log(payload);
      axios.post("event_details", payload)
        .then((response) => {
          //  console.log(response);
          if (response.data.status === 200) {
            //console.log(response.data.data.event_setting_details);
            setEventCategoryAll(response.data.data.AllCategory);
            setCategoriesAll(response.data.data.AllCategories ? response.data.data.AllCategories : []);
            setEventDetailsAll(response.data.data.EventData ? response.data.data.EventData[0] : []);
            
            setEditFlag(response.data.data.EventData ? response.data.data.EventData[0].edit_flag : 0);
            
            const longString = response.data.data.EventData[0] ? response.data.data.EventData[0].name : 'Design Your Event';
            const truncated =
              longString.length > 50
                ? longString.slice(0, 50) + '...'
                : longString;
            // console.log(truncated);
            setEventDispName(truncated);

            setEventTcsPopupFlag(response.data.data.EventData[0] ? response.data.data.EventData[0].tcs_popup : 0);
            setEventTicketsAll(response.data.data.EventTickets ? response.data.data.EventTickets : []);

            setEventTypeAll(response.data.data.AllEventTypes ? response.data.data.AllEventTypes : [])
            setEventCardPreview(response.data.data.PreviewEventDetails ? response.data.data.PreviewEventDetails : []);
            setEventImagesAll(response.data.data.EventImages);
            setEventApiCall(false);
            setYtcrFeePercent(response.data.data.YTCR_FEE_PERCENTAGE);
            setPlatformFeePercent(response.data.data.GST_PERCENTAGE);
            setPaymentGatewayFeePercent(response.data.data.PAYMENT_GATEWAY_FEE_PERCENTAGE);
            setPaymentGatewayGstPercent(response.data.data.PAYMENT_GATEWAY_GST_PERCENTAGE);
            setEventSettingDetails(response.data.data.event_setting_details ? response.data.data.event_setting_details[0] : []);
            setFieldMappingDetails(response.data.data.field_mapping_details ? response.data.data.field_mapping_details : []);
            setCommunicationDetails(response.data.data.communication_details ? response.data.data.communication_details : []);
            setFAQDetails(response.data.data.faq_details ? response.data.data.faq_details : []);
            setTicketsDetails(response.data.data.tickets_details ? response.data.data.tickets_details : []);
            setCouponsDetails(response.data.data.coupon_details ? response.data.data.coupon_details : []);
            setAgeDetails(response.data.data.age_details ? response.data.data.age_details : []);
            setAgeCriteriaDetails(response.data.data.age_criteria_details ? response.data.data.age_criteria_details : []);
            setTermConditionsDetails(response.data.data.terms_conditions_details ? response.data.data.terms_conditions_details : []);
            setEventName(response.data.data.EventData[0] ? response.data.data.EventData[0].name : '');
            setFormTicketsDetails(response.data.data.form_tickets_details ? response.data.data.form_tickets_details : []);
            setCouponTicketsDetails(response.data.data.coupon_tickets_details ? response.data.data.coupon_tickets_details : []);
            setRaceCategoryChargesDetails(response.data.data.race_category_charges_details ? response.data.data.race_category_charges_details : []);
            setOtherPlatformEvent(response.data.data.EventData[0] ? response.data.data.EventData[0].other_platform : 0);

            if (response.data.data.EventData[0]) { setEventTabsClass1(EventTabs === 1 ? 'active' : 'li-done'); setEventSvg1(green_tick_svg); }

            if (response.data.data.EventData[0].pincode) { setEventTabsClass2(EventTabs === 2 ? 'active' : 'li-done'); setEventSvg2(green_tick_svg); }

            if (response.data.data.EventData[0].event_description) { setEventTabsClass3(EventTabs === 3 ? 'active' : 'li-done'); setEventSvg3(green_tick_svg); }

            if (response.data.data.event_setting_details && response.data.data.event_setting_details[0]) { setEventTabsClass4(EventTabs === 4 ? 'active' : 'li-done'); setEventSvg4(green_tick_svg); }

            if ((response.data.data.tickets_details && response.data.data.tickets_details.length > 0) || (response.data.data.EventTickets && response.data.data.EventTickets.length > 0)) { setEventTabsClass5(EventTabs === 5 ? 'active' : 'li-done'); setEventSvg5(green_tick_svg); }

            if (response.data.data.event_form_question_details && response.data.data.event_form_question_details.length > 0) { setEventTabsClass6(EventTabs === 6 ? 'active' : 'li-done'); setEventSvg6(green_tick_svg); }

            if (response.data.data.age_criteria_details && response.data.data.age_criteria_details.length > 0) { setEventTabsClass7(EventTabs === 7 ? 'active' : 'li-done'); setEventSvg7(green_tick_svg); }

            if (response.data.data.coupon_details && response.data.data.coupon_details.length > 0) { setEventTabsClass8(EventTabs === 8 ? 'active' : 'li-done'); setEventSvg8(green_tick_svg); }

            if (response.data.data.comm_selected_flag && response.data.data.comm_selected_flag === 1) { setEventTabsClass9(EventTabs === 9 ? 'active' : 'li-done'); setEventSvg9(green_tick_svg); }

            if (response.data.data.faq_selected_flag && response.data.data.faq_selected_flag === 1) { setEventTabsClass10(EventTabs === 10 ? 'active' : 'li-done'); setEventSvg10(green_tick_svg); }

            if (response.data.data.EventData[0].support_email !== '') { setEventTabsClass11(EventTabs === 11 ? 'active' : 'li-done'); setEventSvg11(green_tick_svg); }

            setLoader(false); setOneTimeLoader(false);
            setEventSettingCategoryFlag(false);
          }
        })
        .catch(() => {
          console.log('error');
          setLoader(false); setOneTimeLoader(false);
        });
    }
  }, [EditEventId, EventApiCall, EventSettingCategoryFlag]);

  // console.log(EditFlag);
  useEffect(() => {
    if (TicketDivShowFlag === true) {
      setDivClass('col-lg-12 col-md-6');
    } else { setDivClass('col-lg-8 col-md-12'); }
  }, [TicketDivShowFlag]);

  //-------------- To check user access rights
  const [orgUserAccessModules, setOrgUserAccessModules] = useState({});
  useEffect(() => {
    axios.post("user_access_rights", {})
      .then((response) => {
        // console.log(response.data.data.user_access_rights);
        setOrgUserAccessModules(response.data.data.user_access_rights);
      })
      .catch((error) => {
        console.error("Access rights error:", error);
      });
  }, []);

  useEffect(() => {
    if (orgUserAccessModules) {
      const access = UserAccessRights({ module_name: "Event", module_display: "no", Data: orgUserAccessModules });
      if (access === true) {
        alert("You don't have any access to this module");
        navigate('/');
      }
    }
  }, [orgUserAccessModules]);

  const handleEventDetails = (e, EventName) => {
    // console.log(EventName);
    if (EventName)
      navigate("/e/" + EventName.replace(/\s/g, '_'));
  }

  return (
    <>
      <ToastContainer theme="colored" />

      <HeaderSecond />
      {loader && oneTimeLoader ? <Loader /> : null}

      <main className="main__content_wrapper">
        {/* Start breadcrumb section */}
        <section className="breadcrumb__section breadcrumb__bg" style={{ backgroundImage: `url(${BreadcrumbBg})` }} >
          <div className="container">
            <div className="row row-cols-1">
              <div className="col">
                <div className="breadcrumb__content">
                  <h1 className="breadcrumb__content--title text-white mb-10" title={EventName}>
                    {EventDispName}
                  </h1>
                  {/* <ul className="breadcrumb__content--menu d-flex">
                    <li className="breadcrumb__content--menu__items">
                      <div className="text-white" onClick={(e) => handleBackToHome(e)}>
                        Home
                      </div>
                    </li>
                    <li className="breadcrumb__content--menu__items">
                      <span className="text-white">Design Your Event</span>
                    </li>
                  </ul> */}
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* End breadcrumb section */}

        <section className="section--padding pt-5">
          <div className="container">

            <div className="event-timeline-ul">

              <div className={'event-timeline-li newtooltip-container ' + EventTabsClass1} onClick={() => {
                setEventTabs(1);
                setEventTabsClass1('active');
                setEventResponceTabs(0);
                setEventApiCall(true);
                setTicketDivShowFlag(false);
              }}>
                <div className="d-flex justify-content-center align-items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d={EventSvg1} /></svg>
                  <span className="newtooltip">Event Essentials</span>
                </div>
              </div>

              <div className={'event-timeline-li newtooltip-container ' + EventTabsClass2} onClick={EditEventId !== 0 ? () => {
                setEventTabs(2);
                setEventTabsClass2('active');
                setEventSvg2(EventSvg1);
                setEventResponceTabs(1);
                setEventApiCall(true);
                setTicketDivShowFlag(false);
              } : null}>
                <div className="d-flex justify-content-center align-items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d={EventSvg2} /></svg>
                  <span className="newtooltip">Event Scheduling</span>
                </div>
              </div>

              <div className={'event-timeline-li newtooltip-container ' + EventTabsClass3} onClick={EditEventId !== 0 ? () => {
                setEventTabs(3);
                setEventTabsClass3('active');
                setEventSvg3(EventSvg1);
                setEventResponceTabs(2);
                setEventApiCall(true);
                setTicketDivShowFlag(false);
              } : null
              }>
                <div className="d-flex justify-content-center align-items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d={EventSvg3} /></svg>
                  <span className="newtooltip">Event Description</span>
                </div>
              </div>

              <div className={'event-timeline-li newtooltip-container ' + EventTabsClass4} onClick={EditEventId !== 0 ? () => {
                setEventTabs(4);
                setEventTabsClass4('active');
                setEventSvg4(EventSvg1);
                setEventResponceTabs(3);
                setEventApiCall(true);
                setTicketDivShowFlag(false);
              } : null
              }>
                <div className="d-flex justify-content-center align-items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d={EventSvg4} /></svg>
                  <span className="newtooltip">Event Settings</span>  {/* Settings */}
                </div>
              </div>

              <div className={'event-timeline-li newtooltip-container ' + EventTabsClass5} onClick={EditEventId !== 0 ? () => {
                setEventTabs(5);
                setEventTabsClass5('active');
                setEventSvg5(EventSvg1);
                setEventResponceTabs(4);
                setEventApiCall(true);
                setTicketDivShowFlag(false);
              } : null
              }>
                <div className="d-flex justify-content-center align-items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d={EventSvg5} /></svg>
                  <span className="newtooltip">Tickets</span> {/* Tickets */}
                </div>
              </div>

              <div className={'event-timeline-li newtooltip-container ' + EventTabsClass6} onClick={EditEventId !== 0 ? () => {
                setEventTabs(6);
                setEventTabsClass6('active');
                setEventSvg6(EventSvg1);
                setEventResponceTabs(5);
                setEventApiCall(true);
                setTicketDivShowFlag(false);
              } : null
              }>
                <div className="d-flex justify-content-center align-items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d={EventSvg6} /></svg>
                  <span className="newtooltip">Form Questions</span>
                </div>
              </div>

              {EditFlag === 1 ?
                <>
                  <div className={'event-timeline-li newtooltip-container ' + EventTabsClass7} onClick={EditEventId !== null ? () => {
                    setEventTabs(7);
                    setEventTabsClass7('active');
                    setEventSvg7(EventSvg1);
                    setEventResponceTabs(6);
                    setEventApiCall(true);
                    setTicketDivShowFlag(false);
                  } : null
                  }>
                    <div className="d-flex justify-content-center align-items-center">
                      <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d={EventSvg7} /></svg>
                      <span className="newtooltip">Age Category</span>
                    </div>
                  </div>

                  <div className={'event-timeline-li newtooltip-container ' + EventTabsClass8} onClick={EditEventId !== null ? () => {
                    setEventTabs(8);
                    setEventTabsClass8('active');
                    setEventSvg8(EventSvg1);
                    setEventResponceTabs(7);
                    setEventApiCall(true);
                    setTicketDivShowFlag(false);
                  } : null
                  }>
                    <div className="d-flex justify-content-center align-items-center">
                      <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d={EventSvg8} /></svg>
                      <span className="newtooltip">Discount Coupons</span>
                    </div>
                  </div>

                  <div className={'event-timeline-li newtooltip-container ' + EventTabsClass9} onClick={EditEventId !== null ? () => {
                    setEventTabs(9);
                    setEventTabsClass9('active');
                    setEventSvg9(EventSvg1);
                    setEventResponceTabs(8);
                    setEventApiCall(true);
                    setTicketDivShowFlag(false);
                  } : null
                  }>
                    <div className="d-flex justify-content-center align-items-center">
                      <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d={EventSvg9} /></svg>
                      <span className="newtooltip">Communications</span>
                    </div>
                  </div>

                  <div className={'event-timeline-li newtooltip-container ' + EventTabsClass10} onClick={EditEventId !== null ? () => {
                    setEventTabs(10);
                    setEventTabsClass10('active');
                    setEventSvg10(EventSvg1);
                    setEventResponceTabs(9);
                    setEventApiCall(true);
                    setTicketDivShowFlag(false);
                  } : null
                  }>
                    <div className="d-flex justify-content-center align-items-center">
                      <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d={EventSvg10} /></svg>
                      <span className="newtooltip">FAQ's</span>
                    </div>
                  </div>

                  <div className={'event-timeline-li newtooltip-container ' + EventTabsClass11} onClick={EditEventId !== null ? () => {
                    setEventTabs(11);
                    setEventTabsClass11('active');
                    setEventResponceTabs(10);
                    setEventSvg11(EventSvg1);
                    setEventApiCall(true);
                    setTicketDivShowFlag(false);
                  } : null
                  }>
                    <div className="d-flex justify-content-center align-items-center">
                      <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d={EventSvg11} /></svg>
                      <span className="newtooltip">Support</span>  {/* Integrations */}
                    </div>
                  </div>
                </>
                : null}
            </div>

            {/* {console.log(EventResponceTabs,EventTabs,EventId)} */}
            <div className="row mt-5">

              <div className={DivClass}>
                {
                  EventTabs === 1 ?
                    <BasicInformation setEventResponceTabs={setEventResponceTabs} setEventBasicInfoMsg={setEventBasicInfoMsg} EventData={EventDetailsAll} EventCategoryData={EventCategoryAll} EventTypeData={EventTypeAll} />

                    : EventTabs === 2 && EditEventId !== 0 && EditEventId ?

                      <EventDuration setEventResponceTabs={setEventResponceTabs} setEventDurationMsg={setEventDurationMsg} EventData={EventDetailsAll} setLoader={setLoader} />

                    : EventTabs === 3 && EditEventId !== 0 && EditEventId ?

                        <EventDescription setEventResponceTabs={setEventResponceTabs} setEventDescriptionMsg={setEventDescriptionMsg} EventData={EventDetailsAll} EventImgData={EventImagesAll} setEventApiCall={setEventApiCall} />

                    : EventTabs === 4 && EditEventId !== 0 && EditEventId && OtherPlatformEvent === 0 ?

                        <Settings setEventResponceTabs={setEventResponceTabs} EventData={EventDetailsAll} EventSettingDetails={EventSettingDetails} YtcrFeePercent={YtcrFeePercent} CategoriesAll={CategoriesAll} setEventSettingCategoryFlag={setEventSettingCategoryFlag} />

                    : EventTabs === 5 && EditEventId !== 0 && EditEventId && OtherPlatformEvent === 0 ?

                        <Tickets setEventResponceTabs={setEventResponceTabs} EventData={EventDetailsAll} EventTicketsAll={EventTicketsAll} setEventApiCall={setEventApiCall} YtcrFeePercent={YtcrFeePercent} PlatformFeePercent={PlatformFeePercent} PaymentGatewayFeePercent={PaymentGatewayFeePercent} setTicketDivShowFlag={setTicketDivShowFlag} TicketDivShowFlag={TicketDivShowFlag} setNewFlag={setNewFlag} NewFlag={NewFlag} EventTypeData={EventTypeAll} PaymentGatewayGstPercent={PaymentGatewayGstPercent} AgeDetails={AgeDetails} RaceCategoryChargesDetails={RaceCategoryChargesDetails} />

                    : EventTabs === 6 && EditEventId !== 0 && EditEventId && OtherPlatformEvent === 0 ?

                        <FormQuestions setEventResponceTabs={setEventResponceTabs} EventData={EventDetailsAll} FieldMappingDetails={FieldMappingDetails} setEventApiCall={setEventApiCall} TicketsDetails={FormTicketsDetails} EditFlag={EditFlag} EventName={EventName}/>    

                    : EventTabs === 7 && EditEventId !== 0 && EditEventId && OtherPlatformEvent === 0 ?
                        
                        <AgeCriteria setEventResponceTabs={setEventResponceTabs} EventData={EventDetailsAll} setTicketDivShowFlag={setTicketDivShowFlag} TicketDivShowFlag={TicketDivShowFlag} FAQDetails={FAQDetails} setEventApiCall={setEventApiCall} TicketsDetails={TicketsDetails} AgeCriteriaDetails={AgeCriteriaDetails} AgeDetails={AgeDetails} />
                             
                    : EventTabs === 8 && EditEventId !== 0 && EditEventId && OtherPlatformEvent === 0 ?
                        
                        <Coupons setEventResponceTabs={setEventResponceTabs} EventData={EventDetailsAll} setTicketDivShowFlag={setTicketDivShowFlag} TicketDivShowFlag={TicketDivShowFlag} setEventApiCall={setEventApiCall} TicketsDetails={CouponTicketsDetails} CouponsDetails={CouponsDetails} />      

                    : EventTabs === 9 && EditEventId !== 0 && EditEventId && OtherPlatformEvent === 0 ?
                        
                        <Communication setEventResponceTabs={setEventResponceTabs} EventData={EventDetailsAll} setTicketDivShowFlag={setTicketDivShowFlag} TicketDivShowFlag={TicketDivShowFlag} CommunicationDetails={CommunicationDetails} setEventApiCall={setEventApiCall} TermConditionsDetails={TermConditionsDetails} />          

                    : EventTabs === 10 && EditEventId !== 0 && EditEventId && OtherPlatformEvent === 0 ?
                        
                        <EventFAQ setEventResponceTabs={setEventResponceTabs} EventData={EventDetailsAll} setTicketDivShowFlag={setTicketDivShowFlag} TicketDivShowFlag={TicketDivShowFlag} FAQDetails={FAQDetails} setEventApiCall={setEventApiCall} />
                                   
                    : EditEventId !== 0 && OtherPlatformEvent === 0 ?
                        
                        <Integration setEventResponceTabs={setEventResponceTabs} EventData={EventDetailsAll} EventName={EventName} EventTcsPopupFlag={EventTcsPopupFlag} />

                    : null
                }

              </div>

              {TicketDivShowFlag === true ?
                ''
                :
                <div className="col-lg-4 col-md-6 d-md-2-none">

                  <aside className="checkout__sidebar sidebar border-radius-10">
                    <h2 className="section__header--title text-center h3 mb-5">
                      Event Preview
                    </h2>
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="card" style={{ borderRadius: 15 }}>

                          {/* EVENT CARD */}

                          <div key={EventCardPreview.id} className="product__items ">
                            <div className="product__items--thumbnail" >
                              <div className="product__items--link">
                                {EventDetailsAll ?
                                  <img
                                    className="product__items--img product__primary--img"
                                    src={EventDetailsAll.banner_image !== '' ? EventDetailsAll.banner_image : event_card_img}
                                    alt="Event View"
                                    style={{ height: '230px', objectFit: 'fill' }}
                                  />
                                  :
                                  <img
                                    className="product__items--img product__primary--img"
                                    src={event_card_img}
                                    alt="Event View"
                                    style={{ height: '230px', objectFit: 'fill' }}
                                  />
                                }
                              </div>
                              {(EventCardPreview.promoted === 1) ?
                                <div className="product__badge style1 special-badge gap-1">
                                  Early Bird
                                </div>
                                : null}
                            </div>

                            <div className="product__items--content cursor-pointer" style={{ height: "200px", overflow: "hidden" }}>

                              <div className="row">
                                <div className="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2 d-flex flex-column align-items-center justify-content-center" style={{ borderRight: "1px solid #f52222" }}>
                                  <h4 className="h4">{EventCardPreview.pre_start_event_month ? EventCardPreview.pre_start_event_month : null}</h4>
                                  <h4 className="h4">{EventCardPreview.pre_start_event_date ? EventCardPreview.pre_start_event_date : null}</h4>
                                </div>
                                <div className="col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 col-xxl-10" >

                                  <h4 className="h4 d-flex" style={{ height: "55px", overflow: "hidden" }}>  {(EventCardPreview.event_name) ? EventCardPreview.event_name : "Event Name"}</h4>
                                </div>
                              </div>

                              <div className='my-3 d-flex gap-3'>

                                <small className="m-0 card-event-city">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    height={17}
                                    viewBox="0 -960 960 960"
                                    width={17}
                                  >
                                    <path d="M480-480q33 0 56.5-23.5T560-560q0-33-23.5-56.5T480-640q-33 0-56.5 23.5T400-560q0 33 23.5 56.5T480-480Zm0 294q122-112 181-203.5T720-552q0-109-69.5-178.5T480-800q-101 0-170.5 69.5T240-552q0 71 59 162.5T480-186Zm0 106Q319-217 239.5-334.5T160-552q0-150 96.5-239T480-880q127 0 223.5 89T800-552q0 100-79.5 217.5T480-80Zm0-480Z" />
                                  </svg> {EventCardPreview.city ? EventCardPreview.city : "City Name"}</small>
                              </div>

                              <div className="row d-flex align-items-center card-rgn-bt-dot">
                                <div className="col-sm-12 mt-4 mb-0">
                                  <small className='mb-2 card-rgn-txt'>Register By
                                    : {" "}  <span className='rgn-date'>{EventCardPreview.registration_end_date ? EventCardPreview.registration_end_date : null}</span></small>
                                </div>

                                <div className="col-sm-6 my-3">
                                  {((EventCardPreview.no_of_tickets > 1) && (EventCardPreview.min_price !== EventCardPreview.max_price)) ?
                                    <p className="current__price m-0"> ₹{EventCardPreview.min_price} - ₹{EventCardPreview.max_price}</p>
                                    :
                                    ((EventCardPreview.no_of_tickets !== 0) && (EventCardPreview.no_of_tickets === 1)) ? <p className="current__price m-0"> ₹{EventCardPreview.max_price}</p> : null
                                  }
                                </div>

                                <div className="col-sm-6 my-3 text-right" onClick={(e) => { handleEventDetails(e, EventDetailsAll.name) }}>
                                  <p className="blog__content--btn primary__btn"
                                  //</div>onClick={(e) => { props.setEventViewFlag(true); props.setEventDetailsId(EventCardPreview.id) }}
                                  >Register</p>
                                </div>
                              </div>

                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </aside>
                </div>
              }
            </div>

          </div>
        </section>

      </main >

    </>
  )
}

export default CreateEvent;

